/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersshowqr2Inputs */

const en_partnersshowqr2 = /** @type {(inputs: Partnersshowqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show QR code`)
};

const de_partnersshowqr2 = /** @type {(inputs: Partnersshowqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code zeigen`)
};

/**
* | output |
* | --- |
* | "Show QR code" |
*
* @param {Partnersshowqr2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersshowqr2 = /** @type {((inputs?: Partnersshowqr2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersshowqr2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersshowqr2(inputs)
	return de_partnersshowqr2(inputs)
});
export { partnersshowqr2 as "partnersShowQr" }